export const DRAWER_WIDTH = 400;
export const MENU_WIDTH = 70;